/**
 * Resolves a relative asset path (e.g., /logo.png, /storage/avatars/xxx.jpg)
 * to the full URL served by the Laravel backend.
 *
 * In Docker, VITE_LARAVEL_PUBLIC_URL should be set to http://localhost:4001
 * (the host-mapped Laravel port). In production, it can be the same origin
 * or an absolute CDN URL.
 *
 * Falls back to the current origin if the env var is not set (works when
 * frontend and backend are served from the same domain).
 */
export function resolveAssetUrl(path: string | null | undefined): string | null {
  if (!path) return null;

  // Already absolute (http/https or data URI) — return as-is
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }

  // Use VITE_LARAVEL_PUBLIC_URL if provided; otherwise assume same origin
  const base = import.meta.env.VITE_LARAVEL_PUBLIC_URL || '';

  // Ensure no double slashes when joining
  if (base && !base.endsWith('/') && !path.startsWith('/')) {
    return `${base}/${path}`;
  }
  return `${base}${path}`;
}
